import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const monthlyEnergy = {
  component: QuestionWrapper,
  componentProps: {
    title: "Let's review your monthly energy use",
    label: 'Energy consumption',
    tooltip:
      "These details help us estimate your household's energy usage to find the best plans for you.",
    tracking: {
      stepName: 'Monthly Energy Use',
      deepStepNumber: 3,
      quickStepNumber: 3,
      deepStepId: '3',
      quickStepId: '3',
    },
  },
  name: 'monthlyEnergy',
  schema: z.object({
    'monthlyEnergy.familySize': z
      .string()
      .min(1, 'Number of people living in your home is required.'),
    'monthlyEnergy.daysAWeekAtHome': z.string().optional(),
    'monthlyEnergy.summerTemp': z.string().optional(),
    'monthlyEnergy.winterTemp': z.string().optional(),
  }),
}
